<template>
    <div class="homeHeader">
      <!-- 顶部logo -->
        <div class="top_logo_box">
          <div class="top_logo">
            <div class="logoImg">
              <router-link to="Home" class="logoImg"><img src="../assets/img/home/logo.png" alt="mpa-logo"></router-link>
            </div>
            <p class="logo_right">国际根节点运行机构、标识注册管理机构</p>
          </div>
        </div>
        <!-- 导航 -->
        <div class="top-header">
            <div class="btnToggle" @click="handleBtnToggle">
                <em></em>
            </div>
            <div class="nav">
                <ul class="navlist isShow">
                    <li class="nav-item" :class="{'area_header':item.path === ''}" v-for="(item,index) of navList" :key="index">
                        <router-link class="nav-item-link" :to='{name:item.path}'>{{item.name}}</router-link>
                        <div class="dropdown">
                            <ul class="nav-two">
                                <li v-for="(sub,index) of item.subNav" :key="index">
                                  <router-link v-if="sub.name!=='一级前缀申请'" :to='{name:sub.path}'>{{sub.name}}</router-link>
                                  <a v-else href="http://prefix.cndona.net:8080/handleDistributeManage/tourist/toSearchPrefix?prefixNameqian=86">{{sub.name}}</a>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="language">
              <!-- <div class="lang_tab currenLang"><router-link to="">简体中文</router-link><a href="http://www.mpacn.net">简体中文</a></div> -->
              <!-- <div class="lang_tab"><a href="http://www.mpacn.net/en/en">English</a></div> -->
              <div class="lang_tab currenLang"><router-link to="/">简体中文</router-link></div>
              <!-- <div class="lang_tab"><router-link to="/en/en">English</router-link></div> -->

              <!-- 北京英文 -->
              <!-- <div class="lang_tab"><a href="http://www.mpacn.net/en/en">English</a></div> -->

              <!-- 青岛英文 -->
              <div class="lang_tab"><a href="http://27.222.23.62/en/en">English</a></div>
            </div>
            <!-- <div class="language">
                <div class="currenLang" @click="handleSelectLang()" :cuttentLanguage = 'cuttentLanguage'>{{language}}</div>
                <div class="langList dropdown">
                  <ul>
                    <li v-for="(item,index) of languageList" :key="index"><a :href="item.url">{{item.name}}</a></li>
                  </ul>
                </div>
            </div> -->
        </div>
        <!-- 移动端 -->
        <!-- <div class="mobile ">
            <div class="logo"><img src="../assets/img/home/logo.png" alt="mpa-logo"></div>
            <div class="nav">
                <ul class="navlist">
                    <li class="nav-item" v-for="(item,index) of navList" :key="index">
                        <router-link class="nav-item-link" :to='item.path'>{{item.name}}</router-link>
                        <div class="dropdown">
                            <ul class="nav-two">
                                <li v-for="(sub,index) of item.subNav" :key="index"><router-link :to='sub.path'>{{sub.name}}</router-link></li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </div> -->
    </div>
</template>

<script>
export default {
  name: 'HomeHeader',
  data () {
    return {
      isShow: false,
      navList: [
        {
          name: '首页',
          path: 'Home'
        },
        {
          name: '产品介绍',
          path: '',
          subNav: [
            {
              name: '前缀产品',
              path: 'zh-prefix'
            },
            {
              name: '多元数据归集系统',
              path: 'zh-MultipleDataAggregation'
            },
            {
              name: '信息路由器',
              path: 'zh-InforRouter'
            },
            {
              name: '数据管理系统',
              path: 'zh-DataManage'
            }
            // {
            //   name: '开发工具箱',
            //   path: 'zh-Toolkit'
            // }
          ]
        },
        {
          name: '解决方案',
          path: '',
          subNav: [
            {
              name: '二级节点',
              path: 'zh-fieldNode'
            },
            {
              name: '全生命周期追溯',
              path: 'zh-LifeCycle'
            },
            {
              name: '类政务',
              path: 'zh-ClassElectronic'
            },
            {
              name: '智能供应链',
              path: 'zh-SmartChain'
            },
            {
              name: '模拟根',
              path: 'zh-SimulationRoot'
            },
            {
              name: 'Handle实验室',
              path: 'zh-laboratory'
            }
          ]
        },
        {
          name: '前缀服务',
          path: '',
          subNav: [
            {
              name: '一级前缀申请',
              path: 'http://prefix.cndona.net:8080/handleDistributeManage/tourist/toSearchPrefix?prefixNameqian=86'
            },
            {
              name: '前缀用户申请',
              path: 'zh-LeveEnd'
            }
          ]
        },
        {
          name: '了解DOA',
          path: '',
          subNav: [
            {
              name: '技术介绍',
              path: 'zh-DOAintroduce'
            },
            {
              name: '技术发明人',
              path: 'zh-Inventor'
            },
            {
              name: '全球架构',
              path: 'zh-DONAFoundation'
            },
            {
              name: 'ATSD',
              path: 'zh-ATSD'
            }
          ]
        },
        {
          name: 'MPA联合体',
          path: 'MPAIntr'
        },
        {
          name: '关于我们',
          path: '',
          subNav: [
            {
              name: '中国一主三辅',
              path: 'zh-Onemian'
            },
            {
              name: '网根北京',
              path: 'zh-NetRootBJ'
            },
            {
              name: '网根青岛',
              path: 'zh-NetRootQD'
            },
            {
              name: '新闻资讯',
              path: 'zh-newsList',
              query: {
                currentPage: '1',
                pageSize: '10'
              }
            },
            {
              name: '合作伙伴',
              path: 'zh-attractinvestment'
            },
            {
              name: '加入我们',
              path: 'zh-JoinUs'
            }
          ]
        },
        {
          name: '技术支持',
          path: '',
          subNav: [
            {
              name: '技术支持与售后',
              path: 'zh-Technical_support_BJ'
            },
            {
              name: '常见问题',
              path: 'zh-FAQ'
            },
            {
              name: '开发者社区',
              path: 'zh-community'
            }
          ]
        }
      ],
      language: '中国站-中文',
      cuttentLanguage: 'zh'
      // languageList: [
      //   {
      //     lang: 'zh',
      //     name: '中国站 - 简体中文',
      //     url: 'http://www.mpacn.net'
      //   },
      //   {
      //     lang: 'en',
      //     name: 'International - EN',
      //     url: 'http://www.mpacn.net/en/en'
      //   }
      // ]
    }
  },
  methods: {
    BtnToggle (protoClassName) {
      const className = document.getElementsByClassName(protoClassName)[0]
      if (className.style.display === 'block') {
        className.style.display = 'none'
      } else {
        className.style.display = 'block'
      }
    },
    handleBtnToggle () {
      this.BtnToggle('isShow')
    }
  }
}
</script>

<style lang="less" scoped>
.homeHeader{
    position: fixed;
    width: 100%;
    background: #1e1939;
    font-size: 16px;
    z-index: 99;
    .top_logo_box{
      width: 100%;
      background-color: #fff;
      .top_logo{
        width: 1200px;
        height: 86px;
        margin: auto;
        display: flex;
        align-items: center;
        .logoImg{
          width: 360px;
          margin-right: auto;
          img{
            width: 100%;
            height: auto;
          }
        }
        .logo_right{
            margin-left: auto;
            font-size: 24px;
            font-weight: bold;
            color: #287cea;
        }
      }
    }
    .top-header{
        display: flex;
        max-width: 1200px;
        height: 66px;
        margin:0 auto;
        .logo{
            padding: 8px 0;
            flex: 1;
            display: flex;
            align-items: center;
            .logoImg{
              width: 100%;
              height: 100%;
              display: block;
            }
            img {
                height: 100%;
                margin: auto;
            }
        }
        .nav{
            color:#fff;
            flex:4;
            .navlist > li{
                position: relative;
                line-height: 66px;
                float: left;
                padding:0 10px;
                a.nav-item-link{
                    color:#fff;
                    height:66px;
                    display: block;
                    padding:0 10px
                }
                .dropdown{
                    position: absolute;
                    top:66px;
                    left: -15px;
                    width:150px;
                    background: #fff;
                    text-align: center;
                    border-bottom-left-radius:5px;
                    border-bottom-right-radius:5px;
                    overflow: hidden;
                    transform: scaleY(0);/*让盒子沿着Y轴缩放，也就是隐藏*/
                    transition: all 0.3s;
                    transform-origin: 50% 0;/*已顶部为中心点缩放 */
                    li{
                        line-height: 50px;
                        padding: 0 2px;
                        a{
                            color: #1e1939;
                            display: block;
                            white-space: nowrap;
                        }
                    }
                    li:hover, li:hover a{
                            background-color: #222348;
                            color: #fff;
                    }
                }
            }
            .navlist > .nav-item:hover{
                .dropdown{
                    transform: scaleY(1)
                }
            }
            .navlist > .nav-item:hover a.nav-item-link {
                font-weight: bold;
            }
        }
        .language{
            // flex:1;
            // display: flex;
            flex-direction: column;
            justify-content: center;
            color:#fff;
            cursor: pointer;
            position: relative;
            .currenLang {
              a {
                color:#fff !important
              }
            }
            .lang_tab {
              padding:0 10px;
              float: left;
              a {
                color: #666375;
                line-height: 66px;
              }
            }
            .lang_tab:hover, .lang_tab:hover a {
              color:#fff
            }
            .langList{
              // display: none;
              position: absolute;
              top:66px;
              left: -35px;
              width:125px;
              background: #fff;
              text-align: center;
              border-bottom-left-radius:5px;
              border-bottom-right-radius:5px;
              overflow: hidden;
              transform: scaleY(0);/*让盒子沿着Y轴缩放，也就是隐藏*/
              transition: all 0.3s;
              transform-origin: 50% 0;/*已顶部为中心点缩放 */
              li{
                  line-height: 50px;
                  padding: 0 2px;
                  a{
                      color: #1e1939;
                      display: block;
                      white-space: nowrap;
                  }
                  .currentLi{
                    background-color: #b5b7db;
                  }
              }
              li:hover, li:hover a{
                      background-color: #222348;
                      color: #fff;
              }
            }
        }
        .language:hover{
          .langList{
            // display: block;
            transform: scaleY(1);
          }
        }
    }
}
@media screen and (max-width: 1000px) {
  .homeHeader{
    height: 50px;
    .top-header{
        display: flex;
        height: 50px;
        margin:0 auto;
        .logo{
            margin-left:20px;
            height:45px;
            padding: 8px 0;
            display: flex;
            align-items: center;
            img {
                height: 100%;
                margin:0
            }
        }
        .btnToggle{
            width:25px;
            height:20px;
            margin-right:20px;
            margin-top:20px;
            em{
                vertical-align: top;
                width: 100%;
                display: inline-block;
                height: 3px;
                position: relative;
                -webkit-transition: all .5s ease;
                transition: all .5s ease;
                background: #fff;
            }
            em:before{
                top:-9px;
                content: '';
                -webkit-transition: .5s all;
                transition: .5s all;
                position: absolute;
                height: 3px;
                width: 100%;
                background: #fff;
                border-radius: 1px;
            }
            em:after{
                content: '';
                -webkit-transition: .5s all;
                transition: .5s all;
                position: absolute;
                top:9px;
                height: 3px;
                width: 100%;
                background: #fff;
                border-radius: 1px;
            }
        }
        .nav{
            position: absolute;
            top: 50px;
            left: 0;
            width: 100%;
            height:auto;
            background: #fff;
            overflow-y: scroll;
            max-height:600px;
        }
        .isShow {
            display: none;
        }
        .nav .navlist > li{
            float:none;
            padding:0;
            // border-bottom: 1px solid #f3f3f3;
            .dropdown{
                position: static;
                max-height: 0;
                background-color:#f8fbff;
                width:100%;
                text-align:left;
                a{
                    padding:0 40px;
                }
            }
        }
        .nav .navlist > li.area_header::after{
            content: '';
            width: 6px;
            height: 6px;
            display: inline-block;
            border-bottom: 2px solid #435361;
            border-left: 2px solid #435361;
            transform: rotate(-45deg);
            position: absolute;
            top: 26px;
            right: 45px;
        }
        .navlist > .nav-item:hover{
            .dropdown{
                max-height:800px;
            }
        }
        .nav .navlist > li a.nav-item-link{
            padding: 0 25px;
            font-size:16px;
            color:#060d13
        }
        .language{
            display: none;
        }
        .navlist > .nav-item:hover{
                .dropdown{
                    height:auto;
                    transform: scaleY(1);
                }
            }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/HomeHeader.vue